/** Service Desk console: Listahan at drawer ng mga kontrata (C08, SD-S3-10). */
export const serviceContracts = {
  title: "Mga kontrata",
  subtitle: "Mga service plan, ang SLA tier na ipinapatupad nila at ang natitirang entitlement. Ang ticket para sa asset na sakop ay kumukuha ng SLA ng kontrata.",
  orgTab: { emptyTitle: "Walang kontrata sa serbisyo", emptyBody: "Gumagamit ng default na SLA ng workspace ang organisasyong ito hangga't hindi ka gumagawa ng kontrata para rito." },
  actions: { create: "Bagong kontrata" },
  kind: { service: "Serbisyo", maintenance: "Maintenance", support: "Suporta", warranty_extension: "Dagdag na warranty" },
  phase: {
    draft: "Draft",
    upcoming: "Magsisimula sa {{start}}",
    active: "Aktibo hanggang {{date}}",
    expiring_one: "Matatapos sa loob ng {{count}} araw",
    expiring_other: "Matatapos sa loob ng {{count}} araw",
    expired: "Nag-expire noong {{date}}",
    cancelled: "Kinansela",
  },
  stats: {
    label: "Buod",
    active: "Ipinapatupad",
    activeHint: "mga kontratang sumasaklaw ngayon",
    expiring: "Malapit nang mag-expire",
    expiringHint: "matatapos sa loob ng 60 araw",
    expired: "Expired na",
    expiredHint: "hindi na-renew",
    draft: "Mga draft",
    draftHint: "hindi pa naa-activate",
  },
  filters: {
    group: "Filter ng status ng kontrata",
    chip: { all: "Lahat", active: "Ipinapatupad", expiring: "Malapit nang mag-expire", expired: "Expired na", draft: "Mga draft" },
    search: "Hanapin ang numero o pangalan",
    searchLabel: "Maghanap ng mga kontrata",
    kind: "Uri ng kontrata",
    allKinds: "Lahat ng uri",
  },
  list: {
    label: "Mga kontrata",
    contract: "Kontrata",
    organisation: "Organisasyon",
    sla: "SLA tier",
    ends: "Nagtatapos",
    entitlements: "Mga entitlement",
    assets: "Mga asset",
    fee: "Bayad",
    noEntitlements: "Walang itinakda",
    allAssets: "Lahat ng asset",
    showing: "Ipinapakita ang {{shown}} sa {{total}} kontrata",
  },
  empty: {
    title: "Wala pang kontrata",
    body: "Gumawa ng service plan para bigyan ang customer ng SLA tier at mga entitlement tulad ng maintenance visit.",
    filteredTitle: "Walang tumutugmang kontrata",
    filteredBody: "I-clear ang filter o maghanap ng ibang kontrata.",
  },
  error: { title: "Hindi ma-load ang mga kontrata", body: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago." },
  coverage: {
    labor: "Trabaho",
    travel: "Biyahe",
    parts: "Mga piyesa",
    covered: "sakop",
    notCovered: "hindi sakop",
    exclusions: "Hindi kasama: {{text}}",
  },
  entitlement: {
    kind: {
      pm_visits: "Mga bisita ng preventive maintenance",
      calibrations: "Mga calibration",
      onsite_visits: "Mga on-site na bisita",
      remote_support_hours: "Oras ng remote support",
      ticket_allowance: "Mga ticket",
    },
    period: { contract: "bawat kontrata", year: "bawat taon ng kontrata", month: "bawat buwan" },
    readout: "{{used}} sa {{quantity}} ang nagamit",
    barLabel: "{{kind}}: {{used}} sa {{quantity}} ang nagamit",
    remaining_one: "{{value}} ang natitira",
    remaining_other: "{{value}} ang natitira",
    over_one: "{{value}} ang lampas sa allowance",
    over_other: "{{value}} ang lampas sa allowance",
    exhausted: "Ubos na",
  },
  banner: {
    expiring_one: "Matatapos sa loob ng {{count}} araw.",
    expiring_other: "Matatapos sa loob ng {{count}} araw.",
    expiringBody: "Pagkasunduan ang renewal sa customer bago bumalik sa default na SLA ng workspace ang mga asset nito.",
    expired: "Nag-expire ang kontratang ito noong {{date}}. Bumabalik sa default na SLA ng workspace ang mga asset nito.",
    cancelled: "Kinansela ang kontratang ito.",
    cancelledReason: "Kinansela ang kontratang ito: {{reason}}",
    draft: "Draft ang kontratang ito. I-activate para ipatupad ang SLA at mabilang ang mga entitlement.",
    exhausted: "Ubos na ang isang entitlement. Lampas na sa kontrata ang susunod na bisita at mamarkahang may bayad.",
  },
  drawer: {
    loading: "Nilo-load ang kontrata",
    notFoundTitle: "Hindi nahanap ang kontrata",
    notFoundBody: "Maaaring natanggal na ito. Bumalik sa listahan para hanapin.",
    organisation: "Organisasyon",
    term: "Panahon",
    termValue: "{{start}} hanggang {{end}}",
    fee: "Bayad",
    billing: "Reference sa billing",
    renewal: "Paalala ng renewal",
    renewalValue_one: "{{count}} araw bago matapos",
    renewalValue_other: "{{count}} araw bago matapos",
    slaChip: "SLA {{name}}",
    entitlements: "Mga entitlement",
    noEntitlements: "Walang itinakdang entitlement. I-edit ang kontrata para magdagdag.",
    coverage: "Saklaw",
    assets: "Mga asset na sakop",
    assetsCount_one: "Mga asset na sakop ({{count}})",
    assetsCount_other: "Mga asset na sakop ({{count}})",
    everyAsset: "Lahat ng asset ng organisasyon, ngayon at sa hinaharap.",
    noAssets: "Wala pang sakop na asset.",
    usage: "Log ng paggamit",
    terms: "Mga tuntunin",
    edit: "I-edit ang kontrata",
    activate: "I-activate",
    activated: "Aktibo na ang {{number}}",
    cancel: "Kanselahin ang kontrata",
    cancelTitle: "Kanselahin ang {{number}}?",
    cancelBody: "Titigil agad ang saklaw ng mga asset nito. Nananatili sa log ng paggamit ang mga entitlement na nabilang na.",
    cancelConfirm: "Kanselahin ang kontrata",
    cancelled: "Kinansela ang {{number}}",
  },
  consume: {
    open: "Bilangin ang paggamit",
    title: "Bilangin ang paggamit",
    description: "Bibilangin ang halaga laban sa {{number}}.",
    entitlement: "Entitlement",
    amount: "Halaga",
    note: "Tala",
    count: "Bilangin",
    counted: "Nabilang ang paggamit",
    waived: "Hindi binilang",
    pastAllowance: "Lampas na iyon sa allowance. Walang nabilang.",
    reason: "Dahilan",
    reasonHint: "Hindi bababa sa {{min}} character. Isinasave ito sa log ng paggamit at audit trail.",
    countAnyway: "Bilangin pa rin",
    waive: "Huwag bilangin",
    problems: { amount: "Maglagay ng halagang higit sa zero na hanggang dalawang decimal.", reason: "Magbigay ng dahilang hindi bababa sa {{min}} character." },
  },
  usage: {
    label: "Paggamit",
    reversed: "Binawi ang paggamit",
    reversedChip: "Binawi",
    notCounted: "Hindi binilang",
    chargeable: "May bayad",
    over: "Lampas sa allowance",
    reverse: "Bawiin",
    reason: "Dahilan: {{reason}}",
    actor: { staff: "Staff", contact: "Client", system: "Sistema", connector: "Connector", import: "Import", visit: "Bisita", automation: "Automation" },
    emptyTitle: "Wala pang paggamit",
    emptyBody: "Lalabas dito ang mga bisita at ticket na binilang laban sa kontratang ito.",
    errorTitle: "Hindi ma-load ang log ng paggamit",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit.",
  },
  form: {
    createTitle: "Bagong kontrata",
    createDescription: "Draft ito hanggang i-activate mo.",
    editTitle: "I-edit ang {{number}}",
    organisation: "Organisasyon",
    chooseOrganisation: "Pumili ng organisasyon",
    name: "Pangalan ng kontrata",
    kind: "Uri",
    startsOn: "Magsisimula sa",
    endsOn: "Magtatapos sa",
    sla: "SLA tier",
    slaHint: "Ipinapatupad sa mga ticket para sa mga asset na sakop.",
    noSla: "Default ng workspace",
    coverage: "Ano ang sakop",
    exclusions: "Hindi kasama",
    entitlements: "Mga entitlement",
    entitlementsHint: "I-tick ang kasama sa kontrata at kung ilan. Iwanang hindi naka-tick ang uring wala.",
    quantityOf: "Dami ng {{kind}}",
    periodOf: "Panahon ng {{kind}}",
    assets: "Mga asset na sakop",
    allAssets: "Lahat ng asset ng organisasyon",
    allAssetsHint: "Sakop din ang mga bagong asset ng organisasyong ito.",
    pickOrganisationFirst: "Pumili muna ng organisasyon.",
    noAssets: "Wala pang asset ang organisasyong ito.",
    price: "Bayad",
    priceHint: "Para sa staff lang, hindi kasama ang VAT.",
    billingRef: "Reference sa billing",
    renewalDays: "Paalala ng renewal (araw)",
    renewalHint: "Gaano katagal bago matapos ipaaalala sa iyo.",
    clientVisiblePrice: "Ipakita ang bayad sa client",
    terms: "Mga tuntunin",
    create: "Gumawa ng kontrata",
    save: "I-save ang mga pagbabago",
    created: "Nagawa ang {{number}}",
    updated: "Na-save ang {{number}}",
  },
  validation: {
    organisation: "Piliin ang organisasyong para sa kontratang ito.",
    name: "Bigyan ang kontrata ng pangalang hanggang {{max}} character.",
    required: "Pumili ng petsa.",
    dates: "Dapat magtapos ang kontrata sa araw ng simula o pagkatapos nito.",
    price: "Maglagay ng halagang zero o higit pa.",
    renewalDays: "Maglagay ng buong bilang ng araw mula 0 hanggang {{max}}.",
    entitlement: "Bigyan ang bawat naka-tick na entitlement ng dami na zero o higit pa.",
    assets: "Pumili ng kahit isang asset, o saklawin ang lahat ng asset ng organisasyon.",
  },
} as const;
